import * as React from "react";
import PropTypes from "prop-types";
import { MenuItem, TextField } from "@material-ui/core";

export const CardStyleSelector = ({
    availableStyles,
    handleStyleChange,
    margin = `normal`,
    selectedOption,
    ...props
}) => {
    React.useEffect(() => {
        if (!availableStyles.includes(selectedOption)) {
            handleStyleChange({ target: { value: availableStyles[0] } });
        }
    }, [availableStyles, handleStyleChange, selectedOption]);

    return (
        <TextField
            disabled={availableStyles.length <= 1}
            id="select-style"
            label="Style"
            margin={margin}
            name="style"
            onChange={handleStyleChange}
            select
            value={selectedOption || availableStyles[0]}
            variant="outlined"
            {...props}
        >
            <MenuItem
                className="text-base px-4 py-2"
                disabled={!availableStyles.includes(`standard`)}
                value="standard"
            >
                Standard
            </MenuItem>
            <MenuItem
                disabled={!availableStyles.includes(`foiled`)}
                value="foiled"
            >
                Foiled
            </MenuItem>
            <MenuItem
                disabled={!availableStyles.includes(`reverse-foiled`)}
                value="reverse-foiled"
            >
                Reverse foiled
            </MenuItem>
        </TextField>
    );
};

CardStyleSelector.propTypes = {
    availableStyles: PropTypes.arrayOf(
        PropTypes.oneOf([`standard`, `foiled`, `reverse-foiled`])
    ).isRequired,
    handleStyleChange: PropTypes.func.isRequired,
    selectedOption: PropTypes.string,
};
